var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccreditationUploader({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.992,
    height: 36.992,
    viewBox: "0 0 36.992 36.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8153",
    "data-name": "Rectangle 8153",
    width: 18.723,
    height: 23.095,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16025",
    "data-name": "Group 16025",
    transform: "translate(-962.754 -415.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    transform: "translate(962.754 452.128) rotate(-90)",
    fill: "#0082ca",
    stroke: "#0082ca",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.496,
    cy: 18.496,
    r: 18.496,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.496,
    cy: 18.496,
    r: 17.996,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15564",
    "data-name": "Group 15564",
    transform: "translate(971.889 421.92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15563",
    "data-name": "Group 15563",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5371",
    "data-name": "Path 5371",
    d: "M15.58,46.219H3.143A3.145,3.145,0,0,1,0,43.078V38.394a1.464,1.464,0,0,1,2.925-.148,1.392,1.392,0,0,1,0,.148v4.684a.216.216,0,0,0,.216.216H15.58a.216.216,0,0,0,.216-.216V38.394a1.464,1.464,0,1,1,2.925-.148,1.392,1.392,0,0,1,0,.148v4.684a3.145,3.145,0,0,1-3.141,3.141",
    transform: "translate(0 -23.123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5372",
    "data-name": "Path 5372",
    d: "M12.978,15.785a1.464,1.464,0,0,1-1.464-1.461V4.983L8.551,7.964a1.457,1.457,0,0,1-2.06.007l-.007-.007a1.457,1.457,0,0,1,0-2.06l0,0L11.942.419a1.49,1.49,0,0,1,2.072,0l5.455,5.462A1.461,1.461,0,1,1,17.4,7.945L14.42,4.983v9.341a1.464,1.464,0,0,1-1.442,1.461",
    transform: "translate(-3.799 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccreditationUploader);
export default __webpack_public_path__ + "static/media/accreditation-uploader.d4b8d6a07beae9e8de8b4bcc2673728f.svg";
export { ForwardRef as ReactComponent };